import React, { useState, useEffect } from 'react';
import companyService from '../../services/companyService';
import styles from './SuperAdminDashboard.module.scss';

interface Company {
  id: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  website: string;
  logo_url: string;
  subdomain?: string;
  is_active: boolean;
  storage_enabled?: boolean;
  created_at: string;
  updated_at: string;
}

interface CompanyStats {
  total_companies: number;
  active_companies: number;
  inactive_companies: number;
  total_employees: number;
  total_customers: number;
  total_invoices: number;
}

const SuperAdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<CompanyStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [recentCompanies, setRecentCompanies] = useState<Company[]>([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      // Fetch overall statistics
      const statsData = await companyService.getOverallStats();
      setStats(statsData);

      // Fetch recent companies
      const companiesData = await companyService.getCompanies();
      setRecentCompanies(companiesData.slice(0, 5)); // Show last 5 companies
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner}></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Super Admin Dashboard</h1>
        <p>Overview of all companies in the system</p>
      </div>

      {stats && (
        <div className={styles.statsGrid}>
          <div className={styles.statCard}>
            <div className={styles.statIcon}>🏢</div>
            <div className={styles.statContent}>
              <h3>{stats.total_companies}</h3>
              <p>Total Companies</p>
            </div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statIcon}>✅</div>
            <div className={styles.statContent}>
              <h3>{stats.active_companies}</h3>
              <p>Active Companies</p>
            </div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statIcon}>⏸️</div>
            <div className={styles.statContent}>
              <h3>{stats.inactive_companies}</h3>
              <p>Inactive Companies</p>
            </div>
          </div>

          {/* <div className={styles.statCard}>
            <div className={styles.statIcon}>👥</div>
            <div className={styles.statContent}>
              <h3>{stats.total_employees}</h3>
              <p>Total Employees</p>
            </div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statIcon}>👤</div>
            <div className={styles.statContent}>
              <h3>{stats.total_customers}</h3>
              <p>Total Customers</p>
            </div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statIcon}>📄</div>
            <div className={styles.statContent}>
              <h3>{stats.total_invoices}</h3>
              <p>Total Invoices</p>
            </div>
          </div> */}
        </div>
      )}

      <div className={styles.recentSection}>
        <h2>Recent Companies</h2>
        <div className={styles.companiesList}>
          {recentCompanies.map((company: Company) => (
            <div key={company.id} className={styles.companyItem}>
              <div className={styles.companyInfo}>
                <h4>{company.name}</h4>
                <p>{company.email}</p>
                {company.subdomain && <p>Subdomain: {company.subdomain}</p>}
                <span className={`${styles.status} ${company.is_active ? styles.active : styles.inactive}`}>
                  {company.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className={styles.companyMeta}>
                <p>Created: {new Date(company.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className={styles.actions}>
        <h2>Quick Actions</h2>
        <div className={styles.actionButtons}>
          <button className={styles.actionButton} onClick={() => window.location.href = '/companies'}>
            <span className={styles.actionIcon}>➕</span>
            <span>Add New Company</span>
          </button>
          <button className={styles.actionButton} onClick={() => window.location.href = '/companies'}>
            <span className={styles.actionIcon}>📊</span>
            <span>Manage Companies</span>
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default SuperAdminDashboard;